import { Calendar, User, Pill, Activity } from 'lucide-react';

const MockupMedicare = () => {
  return (
    <div className='mockup mockup--phone' aria-hidden='true'>
      <div className='mockup-phone-notch' />
      <div className='mockup-phone-screen'>
        <div className='mockup-status-bar'>
          <span>9:41</span>
          <span className='mockup-status-icons'>● ● ●</span>
        </div>
        <div className='mockup-app-header'>
          <div className='mockup-app-logo'>M</div>
          <div>
            <div className='mockup-app-title'>Medicare</div>
            <div className='mockup-app-subtitle'>Hoy, 12 de marzo</div>
          </div>
        </div>
        <div className='mockup-app-body'>
          <div className='mockup-section-title'>Próximos turnos</div>
          <div className='mockup-list-item mockup-list-item--accent'>
            <div className='mockup-list-icon'>
              <Calendar size={16} />
            </div>
            <div className='mockup-list-content'>
              <div className='mockup-list-title'>10:30 — María López</div>
              <div className='mockup-list-meta'>Control general</div>
            </div>
          </div>
          <div className='mockup-list-item'>
            <div className='mockup-list-icon'>
              <User size={16} />
            </div>
            <div className='mockup-list-content'>
              <div className='mockup-list-title'>11:15 — Juan Pérez</div>
              <div className='mockup-list-meta'>Seguimiento</div>
            </div>
          </div>
          <div className='mockup-list-item'>
            <div className='mockup-list-icon'>
              <Pill size={16} />
            </div>
            <div className='mockup-list-content'>
              <div className='mockup-list-title'>12:00 — Ana Torres</div>
              <div className='mockup-list-meta'>Receta digital</div>
            </div>
          </div>
          <div className='mockup-stats-row'>
            <div className='mockup-stat-pill'>
              <Activity size={14} />
              <span>12 turnos hoy</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockupMedicare;
